import React from 'react'

const WealthMethodQuizFunnel = () => {
  return (
    <div>WealthMethodQuizFunnel</div>
  )
}

export default WealthMethodQuizFunnel